import {Component, Input, OnInit} from '@angular/core';
import {DoorMode} from '@model/product/smart-door/smart-door-door-mode.model';

@Component({
  selector: 'app-smartdoor-shadow-details',
  templateUrl: './smartdoor-shadow-details.component.html',
  styleUrls: ['./smartdoor-shadow-details.component.scss']
})
export class SmartdoorShadowDetailsComponent implements OnInit {
  @Input()
  timestamp: string;

  @Input()
  currentMode: DoorMode;

  @Input()
  power: {
    batteryLevel?: number;
    batteryVoltage?: number;
    hasAdapter?: boolean;
    finalAct?: 'LOCKED' | 'UNLOCKED';
  };

  @Input()
  productVariant: string;

  @Input()
  firmware: string;

  constructor() { }

  ngOnInit() {
  }

  batteryIcon(bLevel: number): string {
    if (bLevel > 87.5) {
      return 'battery_full';
    } else if (bLevel > 75) {
      return 'battery_6_bar';
    } else if (bLevel > 62.5) {
      return 'battery_5_bar';
    } else if (bLevel > 50) {
      return 'battery_4_bar';
    } else if (bLevel > 37.5) {
      return 'battery_3_bar';
    } else if (bLevel > 25) {
      return 'battery_2_bar';
    } else if (bLevel > 12.5) {
      return 'battery_1_bar';
    } else {
      return 'battery_0_bar';
    }
  }
}
